import React, {
  Fragment,
  useState,
  useContext,
  useEffect,
  useRef,
} from "react";
import { withRouter, useHistory } from "react-router-dom";
import AuthContext from "../../context/auth/AuthContext";
import AlertContext from "../../context/alert/AlertContext";
import ConfigContext from "../../context/config/ConfigContext";
import Preloader from "./../layout/Preloader";
import useForm from "../../hooks/useForm";
import ReCAPTCHA from "react-google-recaptcha";
import usePageTitle from "../../hooks/usePageTitle";
import { Helmet } from "react-helmet";
import CardContext from "../../context/card/CardContext";
import { env } from "../../env";

const InitRecharge = (props) => {
  const alertContext = useContext(AlertContext);
  const authContext = useContext(AuthContext);
  const configContext = useContext(ConfigContext);
  const cardContext = useContext(CardContext);

  const { getConfigValueByCode, getConfigValueByName } = configContext;
  const { setAlert, clearAlerts } = alertContext;
  const { loading, loginWithEmail, token } = authContext;
  const { loginWithCard } = cardContext;

  const history = useHistory();

  usePageTitle({
    appTitle: props.appTitle,
    pageTitle: "",
  });

  const [user, setUser] = useState({
    email: "",
    cardSerialNo: "",
    confirmCardSerialNo: "",
  });
  const [labels, setLabels] = useState({
    cardSerialNo: "",
    confirmCardSerialNo: "",
    email: "",
  });
  const [captcha, setCaptcha] = useState(false);

  const onCaptcha = (value) => {
    console.log(value);
    if (value) {
      setCaptcha(true);
    }
  };

  const { email, cardSerialNo, confirmCardSerialNo } = user;
  const cardSerialNoRef = useRef(null);
  const confirmCardSerialNoRef = useRef(null);
  const emailRef = useRef(null);

  const cardnumberValRef = useRef();
  cardnumberValRef.current = cardSerialNo;
  const isConfirmCardMatching = (value) => {
    console.log("COnfirm card to match", value);
    let isMatching = false;
    if (cardnumberValRef.current)
      isMatching = cardnumberValRef.current === value;

    return !isMatching ? " is not matching" : "";
  };

  const onChange = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (cardSerialNo !== confirmCardSerialNo) {
      clearAlerts();
      const msg = getConfigValueByCode("patronConfig", "RESPONSE_MSG", 476);
      setAlert(msg, "danger");
    } else {
      clearAlerts();
      const user = {
        email,
        cardSerialNo: cardSerialNo,
      };
      try {
        const res1 = await loginWithEmail(user);
        console.log("Response1: ", res1);
        if (res1 && res1.msgCode) {
          const msg = getConfigValueByCode(
            "generalConfig",
            "RESPONSE_MSG",
            res1.msgCode
          );
          setAlert(msg, res1.status === "ERROR" ? "danger" : "info");
        } else {
          await loginWithCard(res1.data);
          console.log("Redireting to reset link: ");
          history.push("/unreg-recharge-value");
        }
      } catch (err) {
        console.log("Error::::", JSON.stringify(err));
        let errMsg = getConfigValueByCode("generalConfig", "RESPONSE_MSG", 475);
        setAlert(errMsg, "danger");
      }
    }
  };
  // if(reset_link){
  //     // props.history.push('/home');
  //     return <Redirect to='/reset_link' />
  // }
  // const showLogin = () => {
  //   /* To-DO : Call resentLink API */
  //   console.log("Navigate back to Login");
  //   history.push("/");
  // };

  useEffect(() => {
    window.scrollTo({
      top: 0,
    });
    clearAlerts();
    let cardSerialNo = getConfigValueByName(
      "generalConfig",
      "Label",
      "label.cardNumber"
    );
    let confirmCardSerialNo = getConfigValueByName(
      "generalConfig",
      "Label",
      "label.confirmCardNumber"
    );
    let email = getConfigValueByName("generalConfig", "Label", "label.email");
    setLabels({ ...labels, cardSerialNo, confirmCardSerialNo, email });
    //eslint-disable-next-line
  }, []);

  const {
    Popup,
    validateField,
    validateAllFields,
    isFormValid,
    setIsFormValid,
  } = useForm({
    inputList: {
      cardSerialNo: cardSerialNoRef,
      confirmCardSerialNo: confirmCardSerialNoRef,
      email: emailRef,
    },
    customRules: {
      confirmCardSerialNo: isConfirmCardMatching,
    },
    screenName: "AnonymousUserScreen",
  });

  useEffect(() => {
    const isValid = validateAllFields();
    setIsFormValid(isValid);
    console.log("Form is valid", isValid);
    //eslint-disable-next-line
  }, [user]);

  return (
    <Fragment>
      <Helmet>
        <meta
          name="description"
          content="Add cash value to your unregistered METRO Q® Fare Card or METRO Day Pass using a credit card or debit card. The process is quick and easy. Log in here."
        />
      </Helmet>
      <Popup role="alert" aria-relevant="all" />
      {loading && <Preloader />}
      <div className="publicView" role="main" ref={props.mainContentRef}>
        <div className="publicView__PageTitleNote">
          UNREGISTERED METRO FARE CARDS
        </div>

        <div className="publicView__subPageTitleInfo">
          <p>
            You can reload your unregistered METRO fare card using any of the
            following:
          </p>
          <ul>
            <li>• Credit card </li>
            <li>• Debit card </li>
            <li>
              • Transit benefits card that may have been issued to you by
              another organization
            </li>
          </ul>
          <p>
            The amount added may not be available on your card for 24 to 48
            hours. It won’t appear as part of your balance until the next time
            you use your card to pay a fare.
          </p>
          <p>
            Get started by providing the information requested in the boxes
            below.
          </p>
          <ul>
            <li>• Card number fields are required </li>
            <li>
              • Email address is optional (if you wish to receive an email
              receipt of your transaction)
            </li>
            <li>• Click the RELOAD button to log in</li>
          </ul>
        </div>

        <div className="publicView__formBody">
          <form autocomplete="off">
            <div className="publicView__formGroup">
              <label htmlFor="cardSerialNo">
                {labels.cardSerialNo}
                <span className="required" aria-label="Input required">
                  (*Required)
                </span>
                :{" "}
              </label>
              <input
                type="text"
                name="cardSerialNo"
                className="form-control"
                onChange={onChange}
                placeholder={labels.cardSerialNo}
                value={cardSerialNo}
                onBlur={validateField}
                ref={cardSerialNoRef}
                aria-required="true"
                autoComplete="cc-csc"
              />
              <div></div>
            </div>
            <div className="publicView__formGroup">
              <label htmlFor="confirmCardSerialNo">
                {labels.confirmCardSerialNo}
                <span className="required" aria-label="Input required">
                  (*Required)
                </span>
                :{" "}
              </label>
              <input
                type="text"
                name="confirmCardSerialNo"
                className="form-control"
                onChange={onChange}
                placeholder={labels.confirmCardSerialNo}
                value={confirmCardSerialNo}
                onBlur={validateField}
                ref={confirmCardSerialNoRef}
                aria-required="true"
                autoComplete="cc-csc"
              />
              <div></div>
            </div>
            <div className="publicView__formGroup">
              <label htmlFor="email">{labels.email}:</label>
              <input
                type="email"
                name="email"
                className="form-control"
                onChange={onChange}
                placeholder={labels.email}
                value={email}
                onBlur={validateField}
                ref={emailRef}
                aria-required="true"
              />
              <div></div>
            </div>
            <ReCAPTCHA
              className="publicView__formGroup__google-captcha"
              aria-label="google captcha"
              sitekey={env.REACT_APP_HMW_GGL_RECAPTCHA_KEY}
              onChange={onCaptcha}
              onExpired={() => setCaptcha(false)}
            />
            <div className="publicView__actionGroup">
              {/* <input
                type="button"
                value="BACK"
                className="btn btn-block btn-primary"
                onClick={showLogin}
              /> */}
              <button
                type="submit"
                className="btn btn-block btn-primary publicView__actionGroup__submit-button"
                onClick={onSubmit}
                disabled={!(isFormValid && captcha)}
              >
                RELOAD
              </button>
              <div></div>
            </div>
          </form>
          {/* <div className="publicView__subPageTitleNote">
            Note: Registered cards can not be reloaded here. Please
            <strong>
              <a href="/" onClick={showLogin}>
                {" "}
                login
              </a>
            </strong>
            &nbsp;to reload.
          </div> */}
        </div>
      </div>
    </Fragment>
  );
};

export default withRouter(InitRecharge);
